import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Collapse } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import LeftSubMenu from "./LeftSubMenu";
import { getIsAdmin, getUserInfo } from "../../../store/selector/userSelector";
import Notifications from "../../notifications";
import headerLeftMockData from "../../../enum/headerMockupData";
import { calculatorAndToolsSlugs, headerSlugs } from "../../../utils/commonRouteUrl";

export default function LeftMenuSection({ isSidebarOpen, setIsSidebarOpen, isMobileView, isAnnouncementBar }: any) {
  const [openNotification, setOpenNotification] = useState(false);
  const [activeMenu, setActiveMenu] = useState("");
  const [menuId, setMenuId] = useState("");
  const history = useHistory();
  const location = useLocation();
  const userInfo: any = useSelector(getUserInfo);
  const isAdmin: any = useSelector(getIsAdmin);

  const isPro = useMemo(() => {
    return userInfo?.auth_token && (userInfo?.subscription_type === "PRO" || userInfo?.subscription_type === "PRO_MONTH");
  }, [userInfo]);

  const isPremium = useMemo(() => {
    return userInfo?.auth_token && (userInfo?.subscription_type === "PREMIUM" || userInfo?.subscription_type === "PREMIUM_MONTH");
  }, [userInfo]);

  useEffect(() => {
    setActiveMenu(`${location.pathname}${location.search || ""}`);
    if (!isSidebarOpen) {
      setMenuId("");
    }
  }, [location.pathname, location.search, isSidebarOpen]);

  const collapseRef = useRef<HTMLDivElement>(null);

  const activeClass = useMemo(
    () => (path: string) => {
      return activeMenu === path ? "active" : "";
    },
    [activeMenu],
  );

  const openSubMenuHandler = useCallback(
    (item: any) => {
      setMenuId(item.key);
      if (item.key === menuId) {
        setMenuId("");
      }
    },
    [setMenuId, menuId],
  );

  const proRouteUrl = useMemo(
    () => (backupRoute: any, proRoute: boolean, realRoute: any, item?: any) => {
      // eslint-disable-next-line sonarjs/no-collapsible-if
      if (item?.premiumRoute) {
        if (userInfo?.auth_token && (isPro || isPremium || isAdmin)) {
          return realRoute;
        }
      }
      if (userInfo?.auth_token && ((isPro && proRoute) || isAdmin)) {
        return realRoute;
      }
      return backupRoute;
    },
    [isAdmin, isPro, isPremium, userInfo?.auth_token],
  );
  const inviteMailHandler = useCallback(() => {
    window.location.href = "mailto:hello@claritycooperative.com";
  }, []);

  const handleCloseNotification = useCallback(() => {
    setOpenNotification((prev) => !prev); // Toggle openNotification state
  }, []);

  const noRouteMenuHandler = useCallback(
    (item: any) => {
      if (item?.key === "notification") {
        handleCloseNotification();
      } else if (item?.key === "help") {
        inviteMailHandler();
      }
    },
    [handleCloseNotification, inviteMailHandler],
  );

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (collapseRef.current && !collapseRef.current.contains(event.target as Node) && !event.target.closest("#notification")) {
        setOpenNotification(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function isReactRoute(targetRoute: string): boolean {
    let isReact = false;

    const toolboxRoute: any = [
      calculatorAndToolsSlugs?.therapyNotesGenerator(),
      calculatorAndToolsSlugs?.therapistDeductionsCalculator(),
      calculatorAndToolsSlugs?.sessionFeeCalculator(),
      calculatorAndToolsSlugs?.goodFaithEstimateCalculator(),
      calculatorAndToolsSlugs?.outOfNetworkCalculator(),
      headerSlugs?.dashboard,
      headerSlugs?.about,
      headerSlugs?.insurance,
      headerSlugs?.community,
      headerSlugs?.resource,
      headerSlugs?.reportAProblem,
      headerSlugs?.requestAFeature,
      headerSlugs?.visionInsurance,
      headerSlugs?.healthInsurance,
      headerSlugs?.visionInsurance,
    ];

    toolboxRoute.forEach((route: string) => {
      if (targetRoute.includes(route)) isReact = true;
    });
    // Check if the targetRoute exists in the reactRoutes
    return isReact;
  }

  // eslint-disable-next-line @typescript-eslint/default-param-last
  const handleSearchClick = (route: string, refresh: boolean = true, proRoute: any, backupRoute: any, item?: any) => {
    setIsSidebarOpen(false);
    setTimeout(() => {
      if (refresh) {
        history.push(proRouteUrl(backupRoute, proRoute, route, item));
      } else {
        window.location.href = proRouteUrl(backupRoute, proRoute, route, item);
      }
    }, 200);
  };

  return (
    <>
      <div
        className={`sideMenu  ${isMobileView && isSidebarOpen && "open"} 
        ${!isSidebarOpen && isMobileView ? "" : "mobile-open"}
        ${!isMobileView && isSidebarOpen ? "open" : "closed"}
        ${isAnnouncementBar ? "announcement-true" : ""}
        `}
        id="leftMenuMain"
      >
        <ul>
          {headerLeftMockData?.map((item: any) => {
            return (
              <>
                {/* {!item?.subMenu && (
                  <ATagMenu
                    item={item}
                    activeClass={activeClass}
                    proRouteUrl={proRouteUrl}
                    noRouteMenuHandler={noRouteMenuHandler}
                    setIsSidebarOpen={setIsSidebarOpen}
                  />
                )} */}

                <LeftSubMenu
                  item={item}
                  activeClass={activeClass}
                  proRouteUrl={proRouteUrl}
                  noRouteMenuHandler={noRouteMenuHandler}
                  openSubMenuHandler={openSubMenuHandler}
                  menuId={menuId}
                  setIsSidebarOpen={setIsSidebarOpen}
                  handleSearchClick={handleSearchClick}
                  // eslint-disable-next-line react/jsx-no-bind
                  isReactRoute={isReactRoute}
                />
              </>
            );
          })}
        </ul>
      </div>
      {userInfo?.auth_token && (
        <Collapse in={openNotification}>
          <div id="notification-container" style={{ zIndex: "1002" }} ref={collapseRef}>
            <Notifications setCloseNotifications={handleCloseNotification} />
          </div>
        </Collapse>
      )}
    </>
  );
}
